const CreditCardIcon = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42 8H6C3.79086 8 2 9.79086 2 12V36C2 38.2091 3.79086 40 6 40H42C44.2091 40 46 38.2091 46 36V12C46 9.79086 44.2091 8 42 8Z"
      stroke="#00AC9C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 18H46M10 32H14M20 32H30"
      stroke="#00AC9C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const BankIcon = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 40H44V44H4V40ZM8 24H12V38H8V24ZM18 24H22V38H18V24ZM26 24H30V38H26V24ZM36 24H40V38H36V24ZM4 14L24 4L44 14V22H4V14ZM24 16C24.5304 16 25.0391 15.7893 25.4142 15.4142C25.7893 15.0391 26 14.5304 26 14C26 13.4696 25.7893 12.9609 25.4142 12.5858C25.0391 12.2107 24.5304 12 24 12C23.4696 12 22.9609 12.2107 22.5858 12.5858C22.2107 12.9609 22 13.4696 22 14C22 14.5304 22.2107 15.0391 22.5858 15.4142C22.9609 15.7893 23.4696 16 24 16Z"
      fill="#00AC9C"
    />
  </svg>
)

export const paymentMethodConfig = new Map([
  [
    'card',
    {
      icon: CreditCardIcon,
      label: 'Card',
      format: (method: { exp_month?: number | null; exp_year?: number | null }) =>
        `Expired ${method.exp_month}/${method.exp_year}`,
    },
  ],
  [
    'us_bank_account',
    {
      icon: BankIcon,
      label: 'US Bank Account',
      format: (method: { routing_number?: string | null }) =>
        `Routing ${method.routing_number}`,
    },
  ],
])

export const getPaymentMethodConfig = (type: string) => {
  if (!paymentMethodConfig.has(type)) {
    throw new Error('Invalid payment method type. Must be "card" or "us bank account".')
  }
  return paymentMethodConfig.get(type)
}
